import * as Enumerable from "linq";
import { Guid } from "../../utilities/guid";
import { UnitOfWorkObserver } from "../../utilities/unit-of-work-observer";
import { PscDeficiencyModel, PscInspectionModel } from "./psc.models";

export class PscHelper
{
    public static handleDeficienciesBeforeSubmit(uow: UnitOfWorkObserver, item: PscInspectionModel, pscInspectionDeficiencies: PscDeficiencyModel[]) {
        if (item.pscInspectionId > 0) {
            if (item.pscInspectionDeficiencies.length > 0 && !item.knowDeficiencyDetails) {
                Enumerable.from(item.pscInspectionDeficiencies).forEach(def => {
                    def.isActive = false;
                });
                return;
            } else if (pscInspectionDeficiencies.length > 0 && !item.knowDeficiencyDetails) {
                return;
            }
        } else {
            if (item.pscInspectionDeficiencies.length > 0 && !item.knowDeficiencyDetails) {
                delete uow.unitOfWorks['pscInspectionDeficiencies'];
                return;
            } else if (item.pscInspectionDeficiencies.length === 0 && !item.knowDeficiencyDetails) {
                return;
            }
        }
        
        //if the items are not in the pscInspectionDeficiencies loop set the is active to false
        item.pscInspectionDeficiencies.forEach(x=>{
            if(!pscInspectionDeficiencies.find(z=> z.pscInspectionDeficiencyId == x.pscInspectionDeficiencyId)){
                x.isActive = false;
            }
        });

        // exclude inactive deficiencies has these have been deleted
        const activeDeficiencies = item.pscInspectionDeficiencies.filter(x => x.isActive == true);
        Enumerable.from(pscInspectionDeficiencies).forEach((entry, index) => {
            const pscDeficiency: PscDeficiencyModel = activeDeficiencies[index];
            if (pscDeficiency != null) {

                if (entry.isActive) {
                    pscDeficiency.pscInspectionId = entry.pscInspectionId;
                    pscDeficiency.pscDeficiencyId = entry.pscDeficiencyId;
                    pscDeficiency.pscDeficiencyRiskAreaId = entry.pscDeficiencyRiskAreaId;
                    pscDeficiency.pscDeficiencyCategoryId = entry.pscDeficiencyCategoryId;
                    pscDeficiency.pscDeficiencyCategoryFromDeficiencyId = entry.pscDeficiencyCategoryFromDeficiencyId;
                    pscDeficiency.pscDeficiencyAction1Id = entry.pscDeficiencyAction1Id;
                    pscDeficiency.manualDefectText = entry.manualDefectText;
                    pscDeficiency.manualDefectCode = entry.manualDefectCode;
                    pscDeficiency.isActive = entry.isActive;
                    pscDeficiency.closeOutDeficiencySeverityId = entry.closeOutDeficiencySeverityId;
                    pscDeficiency.closeOutPrevActionPreventReoccurFleet = entry.closeOutPrevActionPreventReoccurFleet;
                    pscDeficiency.closeOutPrevActionPreventReoccurVessel = entry.closeOutPrevActionPreventReoccurVessel;
                    pscDeficiency.correctiveActions = entry.correctiveActions;
                    pscDeficiency.preventativeActions = entry.preventativeActions;
                    pscDeficiency.immediateCause = entry.immediateCause;
                    pscDeficiency.rootCause = entry.rootCause;
                }
                else{
                    pscDeficiency.isActive = false;
                }
            }
            else {  
                if(entry.isActive && (!entry.pscInspectionDeficiencyId || entry.pscInspectionDeficiencyId <= 0)){
                    const identifier = Guid.generateGuid();
                    
                    entry['identifier'] = identifier; 
                    item.pscInspectionDeficiencies.push(entry);
                }
            }
        });
    }
}